import styled from 'styled-components';
import { CaptionBoldL } from '../../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../../styles/theme';

export const ReportsNestedHeadCont = styled.div`
  display: flex;
  box-sizing: border-box;
  ${({ theme }: IThemeProvider) => `
    width: calc(100% - ${theme.layout.spacing.mikro});
    padding: ${theme.layout.spacing.mikro} 41px ${theme.layout.spacing.mikro} ${theme.layout.spacing.centy};
    margin: 0 0 ${theme.layout.spacing.mili} 0;
    border-bottom: 1px solid ${theme.colors.neutral.primary[50]};
  `};
`;

export const ReportsNestedHeadContentCont = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 0 0 40px;
`;

interface IHeadName {
  theme: ITheme;
  up?: boolean;
}

export const ReportsNestedHeadSortEl = styled(CaptionBoldL)<IHeadName>`
  position: relative;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  cursor: pointer;
  //width: 180px;
  min-width: 150px;
  max-width: 200px;
  width: 100%;
  @media (min-width: 1360px) {
    min-width: 180px;
    max-width: 300px;
  }
  ${({ theme, up }: IHeadName) => `
    color: ${theme.colors.neutral.primary[80]};
        
   svg {  
    position: relative;
    width: 10px;
    height: 5px;
    margin: 0 0 0 7px;
    ${
      up
        ? `
      top: -2px;
      transform: rotate(180deg);
    `
        : ''
    }
  }
  `};
`;

export const ReportsRegularNestedHeadEl = styled(CaptionBoldL)`
  text-transform: uppercase;
  display: flex;
  align-items: center;
  min-width: 150px;
  max-width: 200px;
  width: 100%;
  @media (min-width: 1360px) {
    min-width: 180px;
    max-width: 300px;
  }
  //width: 180px;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[80]};
  `};
`;

interface IArrowCont {
  asc?: boolean;
  theme: ITheme;
}
export const ArrowCont = styled.div<IArrowCont>`
  svg {
    position: relative;
    top: -2px;
    ${({ asc }) => `
    ${
      asc
        ? `
    transform: rotate(180deg);
    top: -2px;
    `
        : ''
    }
  `};
  }
`;

export const InfoIconCont = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  svg {
    width: 13.33px;
    height: 13.33px;
  }
  ${({ theme }: IThemeProvider) => `
      margin: 0 0 0 ${theme.layout.spacing.mikro};
  `};
`;
